import { render, staticRenderFns } from "./mr_collapsible_extension.vue?vue&type=template&id=c8a240e8"
import script from "./mr_collapsible_extension.vue?vue&type=script&lang=js"
export * from "./mr_collapsible_extension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports